import React, { useEffect } from 'react';
import './monitorFilters.css';
import { useDispatch, useSelector } from "react-redux";
import {
    dropdownAction,
    filterCoachesOptionsAction,
    filterTypesOptionsAction,
    filterWindowAction,
    firstCurrentVisitorsRequestAction,
    resetAllFiltersAction
} from "../../redux/rootReducer";
import { currentVisitorsSagaAction } from "../../redux/sagaActions";
import FilterSelect from "../FilterSelect/FilterSelect";
import FiltersWrapper from "../FiltersWrapper/FiltersWrapper";

const MonitorFilters = () => {
    const dispatch = useDispatch();

    const currentEstablishment = useSelector(state => state.currentEstablishment);
    const dropdown = useSelector(state => state.dropdown);
    const subscription_types = useSelector(state => state.subscription_types);
    const subscription_coaches = useSelector(state => state.subscription_coaches);
    const filterTypesOptions = useSelector(state => state.filterTypesOptions);
    const filterCoachesOptions = useSelector(state => state.filterCoachesOptions);

    useEffect(() => {
        dispatch(filterTypesOptionsAction(subscription_types.map(elem => ({ ...elem, active: false }) )));
        dispatch(filterCoachesOptionsAction(subscription_coaches.filter(el => el.id).map(elem => ({ ...elem, active: false }) )));
    }, [subscription_types, subscription_coaches]);

    return (
        <div className="monitor__filters">
            <FiltersWrapper>
                <div className="flt__content">
                    <div className="flt__reset" onClick={ () => {
                        // Сброс фильтров
                        dispatch(resetAllFiltersAction());
                    } }>Сбросить фильтры</div>
                    <div className="flt__caption">Фильтры</div>
                    <div className="select__wrapper">
                        <FilterSelect
                            options={ filterTypesOptions }
                            handler={ id => dispatch(filterTypesOptionsAction(filterTypesOptions.map(elem => {
                                // Меняем состояние выбранных элементов
                                if (elem.id === id) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                            placeholder={ 'Тип абонемента' }
                            open={ dropdown === 'filter_types' }
                            openHandler={ () => dispatch(dropdownAction('filter_types')) }
                            clear={ () => dispatch(filterTypesOptionsAction(filterTypesOptions.map(elem => {

                                if (elem.active) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                        />
                    </div>
                    <div className="select__wrapper">
                        <FilterSelect
                            options={ filterCoachesOptions }
                            handler={ id => dispatch(filterCoachesOptionsAction(filterCoachesOptions.map(elem => {
                                // Меняем состояние выбранных элементов
                                if (elem.id === id) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                            placeholder={ 'Тренер' }
                            open={ dropdown === 'filter_coaches' }
                            openHandler={ () => dispatch(dropdownAction('filter_coaches')) }
                            clear={ () => dispatch(filterCoachesOptionsAction(filterCoachesOptions.map(elem => {

                                if (elem.active) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                        />
                    </div>
                    <div className="button button--blue"
                         onClick={ () => {
                             // Закрываем фильтры
                             dispatch(filterWindowAction(false));

                             dispatch(firstCurrentVisitorsRequestAction(false));
                             dispatch(currentVisitorsSagaAction({
                                 establishment: currentEstablishment,
                                 subscription_type: JSON.stringify(filterTypesOptions.filter(el => el.active).map(el => el.id)),
                                 subscription_coach: JSON.stringify(filterCoachesOptions.filter(el => el.active).map(el => el.id)),
                                 preloader: true
                             }));
                         } }
                    >Применить</div>
                </div>
            </FiltersWrapper>
        </div>
    );
};

export default MonitorFilters;